import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { palette } = useTheme()
    const { colors } = useContextState()
    return {
        containerHeader: {
            width: '100%',
            display: 'flex',
            gap: 2,
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        headerTitle: {
            fontSize: '16px',
            flex: '1 0 200px',
            fontWeight: '600'
        },
        headerAction: {
            fontSize: '14px',
            flex: '0 1 300px',
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            gap: 2,
            '& .span': {
                fontWeight: '800'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '30px'
            },
            '& .separator': {
                borderRight: '1px solid #000',
                paddingRight: '10px'
            }
        },
        arrow: {
            padding: 0,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        },
        rotate: (expand: boolean) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
        accordion: {
            /* '&.MuiAccordion-root':{
                marginBottom: 2
            }, */
            '& .MuiAccordion-root.Mui-expanded': {
                margin: 0
            },
            '& .MuiAccordionSummary-root.Mui-expanded': {
                marginBottom: 2,
            }
        },
        headerActionCounter: {
            minWidth: '120px',
            textAlign: 'center'
        },
        headerValue: {
            minWidth: '78px',
            textAlign: 'center'
        },
        description: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& .MuiPaper-root':{
                boxShadow: 'none'
            }
        },
        borderB: {
            width: '100%',
            height: '1px',
            left: '0px',
            bottom: '0px',
            position: 'absolute',
            boxShadow: `0px 2px 3px ${palette.grey[400]}`,
        },
        container:{
            marginBottom: 2
        },
        header: {
            backgroundColor:colors.color1, 
            width:'120px', 
            padding: '10px 15px 0px 15px', 
            textAlign: 'center', 
            borderRadius: '5px 5px 0px 0px',
            fontSize: '16px',
            fontWeight: '600',
            color: 'white'
        },
        headerBorder: {
            backgroundColor:colors.color1, 
            padding: '10px 0px 0px 0px', 
            borderRadius: '0px 5px 5px 5px',
            borderLeft: `1px solid ${colors.color13}`,
            borderRight: `1px solid ${colors.color13}`,
            borderBottom: `1px solid ${colors.color13}`,
            
        }
    }
}

export { useStyles }